import type {
  DropdownMenuItemType,
} from '../createDropdownMenu';

import { RemoveTableAction } from './RemoveTableAction';
import type {
  RemoveTableActionProps,
} from './RemoveTableAction';

export type CreateRemoveTableActionDropdownParams = Omit<DropdownMenuItemType, 'render'>;

export type CreateRemoveTableActionParams = Omit<RemoveTableActionProps, 'children' | 'className'>;

export const defaultRenderIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.0837 2.5H7.91699L7.08366 3.33333H4.16699V5H15.8337V3.33333H12.917L12.0837 2.5ZM13.3337 7.5V15.8333H6.66699V7.5H13.3337ZM5.00033 5.83333H15.0003V15.8333C15.0003 16.75 14.2503 17.5 13.3337 17.5H6.66699C5.75033 17.5 5.00033 16.75 5.00033 15.8333V5.83333Z"
    />
  </svg>
);

export const createRemoveTableAction = (
  params: CreateRemoveTableActionDropdownParams,
  props: CreateRemoveTableActionParams,
): DropdownMenuItemType => ({
  render: ({
    children,
    className,
  }) => (
    <RemoveTableAction
      {...props}
      className={className}
    >
      {children}
    </RemoveTableAction>
  ),

  renderIcon: defaultRenderIcon,
  label: 'Удалить',

  ...params,
});
